'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_COMMENTS':
      return action.payload.reduce(function (state, data) {
        return state.mergeIn(['one', data.comments.id], (0, _immutable.fromJS)(data.comments));
      }, state);

    case 'DELETE_COMMENTS':
      return action.payload.reduce(function (state, comment) {
        return state.deleteIn(['one', comment.id]);
      }, state);

    case 'CREATE_COMMENT':
    case 'UPDATE_COMMENT':
      return state.setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload));

    case 'DELETE_COMMENT':
      return state.deleteIn(['one', action.score_id]);

    case 'GET_RESULTS':
      {
        return action.payload.reduce(function (state, data) {
          return data.comments && state.setIn(['one', data.comments.id], (0, _immutable.fromJS)(data.comments)) || state;
        }, state);
      }

    case 'GET_ALL_EVENT_SCORES':
      {
        var comments = action.payload.map(function (adj) {
          return adj.comments;
        });
        return comments.flat().reduce(function (state, comment) {
          return state.mergeIn(['one', comment.id], (0, _immutable.fromJS)(comment));
        }, state);
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/comments/index.js
// module id = 690
// module chunks = 0